import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d8c76b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1 text-size-14 text-mild" }, "生年月日", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-mild" }, "現住所を入力してください", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1 mb-0 text-size-14 text-mild" }, "\n        番地まで\n      ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "d-block mt-1 mb-2 text-size-10 text-mild" }, "\n        (市のあとに区がある地域は区から入力してください)\n      ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-size-12 text-mild" }, "入力例: 港北区日吉〇-〇-〇", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-size-12 text-mild" }, "入力例: △△マンション 101号", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextFieldGroup = _resolveComponent("TextFieldGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_FormRadioGroup = _resolveComponent("FormRadioGroup")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_FormSelectGroup = _resolveComponent("FormSelectGroup")!
  const _component_AddressChoiceModal = _resolveComponent("AddressChoiceModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_BRow, { class: "mx-n2" }, {
        default: _withCtx(() => [
          _createVNode(_component_BCol, { class: "px-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "姓",
                rules: "required",
                vid: "lastName",
                modelValue: _ctx.inputValues.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues.lastName) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    id: "lastName",
                    modelValue: _ctx.inputValues.lastName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.lastName) = $event)),
                    label: "名前",
                    placeholder: "介助",
                    appLabelText: "必須",
                    type: "text",
                    class: "mb-3",
                    disabled: _ctx.isDisable,
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "disabled", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BCol, { class: "px-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "名",
                rules: "required",
                vid: "firstName",
                modelValue: _ctx.inputValues.firstName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValues.firstName) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    id: "firstName",
                    modelValue: _ctx.inputValues.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValues.firstName) = $event)),
                    placeholder: "太郎",
                    type: "text",
                    class: "mb-3 mt-4 pt-2",
                    disabled: _ctx.isDisable,
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "disabled", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_BRow, { class: "mx-n2" }, {
        default: _withCtx(() => [
          _createVNode(_component_BCol, { class: "px-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "セイ",
                rules: "required|hankaku_kana",
                vid: "lastNameKana",
                modelValue: _ctx.inputValues.lastNameKana,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValues.lastNameKana) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    modelValue: _ctx.inputValues.lastNameKana,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputValues.lastNameKana) = $event)),
                    label: "フリガナ",
                    placeholder: "カイテク",
                    appLabelText: "必須",
                    type: "text",
                    class: "mb-3",
                    disabled: _ctx.isDisable,
                    "validation-state": validationState,
                    onBlur: () => _ctx.onBlurLastNameKana(validationState.handleChange)
                  }, null, 8, ["modelValue", "disabled", "validation-state", "onBlur"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BCol, { class: "px-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "メイ",
                rules: "required|hankaku_kana",
                vid: "firstNameKana",
                modelValue: _ctx.inputValues.firstNameKana,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputValues.firstNameKana) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    modelValue: _ctx.inputValues.firstNameKana,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValues.firstNameKana) = $event)),
                    placeholder: "タロウ",
                    type: "text",
                    class: "mb-3 mt-4 pt-2",
                    "validation-state": validationState,
                    disabled: _ctx.isDisable,
                    onBlur: () => _ctx.onBlurFirstNameKana(validationState.handleChange)
                  }, null, 8, ["modelValue", "validation-state", "disabled", "onBlur"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_BForm, null, {
        default: _withCtx(() => [
          _createVNode(_component_ValidationProvider, {
            name: "性別",
            rules: "required",
            vid: "sex",
            modelValue: _ctx.inputValues.sex,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputValues.sex) = $event))
          }, {
            default: _withCtx((validationState) => [
              _createVNode(_component_FormRadioGroup, {
                label: "性別",
                appLabelText: "必須",
                name: "性別",
                modelValue: _ctx.inputValues.sex,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputValues.sex) = $event)),
                options: _ctx.genderOptions,
                class: "mb-3",
                disabled: _ctx.isUnderExamination,
                "validation-state": validationState
              }, null, 8, ["modelValue", "options", "disabled", "validation-state"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _hoisted_1,
      _createTextVNode(),
      _createVNode(_component_AppLabel, { variant: "red" }, {
        default: _withCtx(() => [
          _createTextVNode("必須")
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_BRow, { class: "mx-n2" }, {
        default: _withCtx(() => [
          _createVNode(_component_BCol, {
            cols: "4",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "誕生年",
                rules: "required",
                vid: "birthDateYear",
                modelValue: _ctx.birthDateYear,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.birthDateYear) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormSelectGroup, {
                    disabled: _ctx.isDisable,
                    modelValue: _ctx.birthDateYear,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.birthDateYear) = $event)),
                    options: _ctx.birthDateYearOptions,
                    firstOption: "年",
                    class: "mb-3",
                    "validation-state": validationState,
                    onMousedown: 
              () => _ctx.onMouseDownBirthDateYear(validationState.handleChange)
            
                  }, null, 8, ["disabled", "modelValue", "options", "validation-state", "onMousedown"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BCol, {
            cols: "4",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "誕生月",
                rules: "required",
                vid: "birthDateMonth",
                modelValue: _ctx.birthDateMonth,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.birthDateMonth) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormSelectGroup, {
                    disabled: _ctx.isDisable,
                    label: "",
                    modelValue: _ctx.birthDateMonth,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.birthDateMonth) = $event)),
                    options: _ctx.birthDateMonthOptions,
                    firstOption: "月",
                    class: "mb-3",
                    "validation-state": validationState
                  }, null, 8, ["disabled", "modelValue", "options", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BCol, {
            cols: "4",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "誕生日",
                rules: "required",
                vid: "birthDateDay",
                modelValue: _ctx.birthDateDay,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.birthDateDay) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormSelectGroup, {
                    disabled: _ctx.isDisable,
                    modelValue: _ctx.birthDateDay,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.birthDateDay) = $event)),
                    options: _ctx.birthDateDayOptions,
                    firstOption: "日",
                    class: "mb-3",
                    "validation-state": validationState,
                    ref: "birthDateDay"
                  }, null, 8, ["disabled", "modelValue", "options", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_ValidationProvider, {
        name: "メールアドレス",
        rules: "required|email",
        vid: "email",
        modelValue: _ctx.inputValues.email,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.inputValues.email) = $event))
      }, {
        default: _withCtx((validationState) => [
          _createVNode(_component_TextFieldGroup, {
            modelValue: _ctx.inputValues.email,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inputValues.email) = $event)),
            label: "メールアドレス",
            placeholder: "example@example.com",
            appLabelText: "必須",
            disabled: _ctx.isDisable,
            type: "email",
            class: "mb-3",
            "validation-state": validationState
          }, null, 8, ["modelValue", "disabled", "validation-state"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(),
      _createVNode(_component_BRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_BCol, {
            cols: "12",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_BRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_BCol, { cols: "5" }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "郵便番号",
                rules: "required|length:7",
                vid: "postalCode",
                modelValue: _ctx.inputValues.postalCode,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.inputValues.postalCode) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    modelValue: _ctx.inputValues.postalCode,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inputValues.postalCode) = $event)),
                    label: "郵便番号",
                    placeholder: "1000000",
                    inputmode: "numeric",
                    appLabelText: "必須",
                    type: "text",
                    class: "mb-3",
                    maxlength: "7",
                    "validation-state": validationState,
                    disabled: _ctx.isUnderExamination,
                    onChange: _ctx.onChangePostalCode
                  }, null, 8, ["modelValue", "validation-state", "disabled", "onChange"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_BRow, { class: "mx-n2" }, {
        default: _withCtx(() => [
          _createVNode(_component_BCol, {
            cols: "5",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "都道府県",
                rules: "required",
                vid: "prefecture",
                modelValue: _ctx.inputValues.prefecture,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inputValues.prefecture) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormSelectGroup, {
                    label: "都道府県",
                    appLabelText: "必須",
                    modelValue: _ctx.inputValues.prefecture,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.inputValues.prefecture) = $event)),
                    options: _ctx.prefectureOptions,
                    class: "mb-3",
                    "validation-state": validationState,
                    disabled: _ctx.isUnderExamination,
                    ref: "prefecture"
                  }, null, 8, ["modelValue", "options", "validation-state", "disabled"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BCol, {
            cols: "7",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "市区町村",
                rules: "required",
                vid: "locality",
                modelValue: _ctx.inputValues.locality,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.inputValues.locality) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormSelectGroup, {
                    label: "市区町村",
                    appLabelText: "必須",
                    modelValue: _ctx.inputValues.locality,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inputValues.locality) = $event)),
                    options: _ctx.localityOptions,
                    class: "mb-3",
                    "validation-state": validationState,
                    disabled: _ctx.isUnderExamination,
                    ref: "locality"
                  }, null, 8, ["modelValue", "options", "validation-state", "disabled"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_ValidationProvider, {
        name: "番地まで",
        rules: "required",
        vid: "address1",
        class: "mb-3",
        modelValue: _ctx.inputValues.address1,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.inputValues.address1) = $event))
      }, {
        default: _withCtx((validationState) => [
          _hoisted_3,
          _createTextVNode(),
          _createVNode(_component_AppLabel, { variant: "red" }, {
            default: _withCtx(() => [
              _createTextVNode("必須")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _hoisted_4,
          _createTextVNode(),
          _createVNode(_component_TextFieldGroup, {
            modelValue: _ctx.inputValues.address1,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.inputValues.address1) = $event)),
            type: "text",
            "validation-state": validationState,
            disabled: _ctx.isUnderExamination,
            ref: "address1"
          }, null, 8, ["modelValue", "validation-state", "disabled"]),
          _createTextVNode(),
          _hoisted_5
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(),
      _createVNode(_component_ValidationProvider, {
        name: "建物名・部屋番号",
        rules: "max:500",
        vid: "address2",
        class: "mb-3",
        modelValue: _ctx.inputValues.address2,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.inputValues.address2) = $event))
      }, {
        default: _withCtx((validationState) => [
          _createVNode(_component_TextFieldGroup, {
            modelValue: _ctx.inputValues.address2,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.inputValues.address2) = $event)),
            label: "建物名・部屋番号",
            appLabelText: "任意",
            appLabelVariant: "mild",
            type: "text",
            "validation-state": validationState,
            disabled: _ctx.isUnderExamination
          }, null, 8, ["modelValue", "validation-state", "disabled"]),
          _createTextVNode(),
          _hoisted_6
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(),
      (_ctx.showsWorkerService)
        ? (_openBlock(), _createBlock(_component_BForm, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "業務カテゴリ",
                rules: "required",
                vid: "workerService",
                modelValue: _ctx.inputValues.workerService,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.inputValues.workerService) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormRadioGroup, {
                    label: "業務カテゴリ",
                    appLabelText: "必須",
                    name: "業務カテゴリ",
                    modelValue: _ctx.inputValues.workerService,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.inputValues.workerService) = $event)),
                    options: _ctx.workerServiceOptions,
                    class: "mb-3",
                    disabled: _ctx.isUnderExamination,
                    "validation-state": validationState,
                    description: "お仕事検索、資格登録で自動的に業務カテゴリに沿ったものが表示されます。マイページからいつでも変更可能です"
                  }, null, 8, ["modelValue", "options", "disabled", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createTextVNode(),
    (_ctx.isAddressChoiceModalShown)
      ? (_openBlock(), _createBlock(_component_AddressChoiceModal, {
          key: 0,
          addresses: _ctx.addressOptions,
          onAddressChosen: _ctx.onAddressChosen
        }, null, 8, ["addresses", "onAddressChosen"]))
      : _createCommentVNode("", true)
  ], 64))
}